module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-users panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('panel-search', {
    attrs: {
      "placeholder": "Введите фио, телефон или почту для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    attrs: {
      "id": "result-form-search"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_ids),
        expression: "selected_ids"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("id-" + (user.id))
      },
      domProps: {
        "value": user.id,
        "checked": Array.isArray(_vm.selected_ids) ? _vm._i(_vm.selected_ids, user.id) > -1 : (_vm.selected_ids)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = user.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected_ids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_ids = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("id-" + (user.id))
      }
    }, [_c('span')])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.full_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))])])
  }), _vm._v(" "), (_vm.users != null && _vm.users.length < 1) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Поиск")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.next_page_url) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("Еще")]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.selected_users), function(user) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_ids),
        expression: "selected_ids"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("id-selected-" + (user.id)),
        "name": _vm.name
      },
      domProps: {
        "value": user.id,
        "checked": Array.isArray(_vm.selected_ids) ? _vm._i(_vm.selected_ids, user.id) > -1 : (_vm.selected_ids)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = user.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected_ids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_ids = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("id-selected-" + (user.id))
      }
    }, [_c('span')])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.full_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))])])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', [_vm._v("Пользователи")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("ФИО")]), _vm._v(" "), _c('th', [_vm._v("Логин")]), _vm._v(" "), _c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("E-mail")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', [_vm._v("Выбранные пользователи")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("ФИО")]), _vm._v(" "), _c('th', [_vm._v("Логин")]), _vm._v(" "), _c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("E-mail")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1396198c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1396198c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SelectUsers.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1396198c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SelectUsers.vue
// module chunks = 0